import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
// import { ThreeDot } from "react-loading-indicators";
// import { set } from "date-fns";
import { Check } from "lucide-react";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ExperienceForm = ({
  onClose,
  onSave,
  defaultValues,
  fetchExperiences = {},
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "onChange",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  const is_current = watch("is_current");

  const onSubmit = async (data) => {
    const token = localStorage.getItem("access_token");
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("employment_type", data.employment_type || "");
    formData.append("company", data.company);
    formData.append("is_current", data.is_current);
    formData.append("start_month", data.start_month || "");
    formData.append("start_year", data.start_year || "");
    formData.append("end_month", data.end_month || "");
    formData.append("end_year", data.end_year || "");
    formData.append("location", data.location || "");
    formData.append("location_type", data.location_type || "");
    formData.append(
      "skills",
      Array.isArray(data.skills) ? data.skills.join(",") : data.skills || ""
    );
    formData.append("description", data.description || "");

    if (data.media instanceof FileList && data.media.length > 0) {
      formData.append("media", data.media[0]);
    }

    if (defaultValues?.id) {
      formData.append("id", defaultValues.id);
      try {
        setLoading(true);
        await axios.patch(`${BASE_URL}/user/portfolio/experience/`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        });
        onSave();
        onClose();
      } catch (error) {
        console.error(
          "Error updating experience:",
          error.response?.data || error
        );
      } finally {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        await axios.post(`${BASE_URL}/user/portfolio/experience/`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        });
        onSave();
        onClose();
      } catch (error) {
        console.error(
          "Error submitting experience:",
          error.response?.data || error
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    // <div className="experience-form-container">
    //   <form onSubmit={handleSubmit(onSubmit)}>
    //     <div className="experience-form-field">
    //       <label>
    //         Title <span style={{ color: "red" }}>*</span>
    //       </label>
    //       <input
    //         {...register("title", { required: true })}
    //         placeholder="Ex: Retail Sales Manager"
    //       />
    //     </div>

    //     <div className="experience-form-field">
    //       <label>Employment Type</label>
    //       <select {...register("employment_type")}>
    //         <option value="">Please select</option>
    //         <option value="Full-time">Full-time</option>
    //         <option value="Part-time">Part-time</option>
    //         <option value="Internship">Internship</option>
    //         <option value="Freelance">Freelance</option>
    //       </select>
    //     </div>

    //     <div className="experience-form-field">
    //       <label>
    //         Company or Organization <span style={{ color: "red" }}>*</span>
    //       </label>
    //       <input
    //         {...register("company", { required: true })}
    //         placeholder="Ex: Microsoft"
    //       />
    //     </div>

        // <div className="experience-form-field">
        //   <label>
        //     <input
        //       type="checkbox"
        //       {...register("is_current")}
        //       style={{ marginRight: "8px" }}
        //     />
        //     I am currently working in this role
        //   </label>
        // </div>

    //     <div className="experience-form-row">
    //       <div className="experience-form-field">
    //         <label>
    //           Start Month <span style={{ color: "red" }}>*</span>
    //         </label>
    //         <select {...register("start_month")}>
    //           <option value="">Month</option>
    //           {[
    //             "January",
    //             "February",
    //             "March",
    //             "April",
    //             "May",
    //             "June",
    //             "July",
    //             "August",
    //             "September",
    //             "October",
    //             "November",
    //             "December",
    //           ].map((m) => (
    //             <option key={m} value={m}>
    //               {m}
    //             </option>
    //           ))}
    //         </select>
    //       </div>
    //       <div className="experience-form-field">
    //         <label>Start Year</label>
    //         <input
    //           type="number"
    //           {...register("start_year", {
    //             required: "Start year is required",
    //             min: { value: 1900, message: "Year cannot be before 1900" },
    //             max: {
    //               value: new Date().getFullYear() + 5,
    //               message: "Year seems too far in the future",
    //             },
    //             validate: (value) =>
    //               /^\d{4}$/.test(value) || "Year must be a 4-digit number",
    //           })}
    //           placeholder="Year"
    //         />
    //         {errors.start_year && (
    //           <p className="error-message">{errors.start_year.message}</p>
    //         )}
    //       </div>
    //     </div>

    //     {!is_current && (
    //       <div className="experience-form-row">
    //         <div className="experience-form-field">
    //           <label>End Month</label>
    //           <select {...register("end_motnh")}>
    //             <option value="">Month</option>
    //             {[
    //               "January",
    //               "February",
    //               "March",
    //               "April",
    //               "May",
    //               "June",
    //               "July",
    //               "August",
    //               "September",
    //               "October",
    //               "November",
    //               "December",
    //             ].map((m) => (
    //               <option key={m} value={m}>
    //                 {m}
    //               </option>
    //             ))}
    //           </select>
    //         </div>
    //         <div className="experience-form-field">
    //           <label>End Year</label>
    //           <input
    //             type="number"
    //             {...register("end_year", {
    //               required: "End year is required",
    //               min: { value: 1900, message: "Year cannot be before 1900" },
    //               max: {
    //                 value: new Date().getFullYear() + 5,
    //                 message: "Year seems too far in the future",
    //               },
    //               validate: (value) => {
    //                 const startYear = watch("start_year");
    //                 return (
    //                   !value ||
    //                   parseInt(value) >= parseInt(startYear) ||
    //                   "End year must be after start year"
    //                 );
    //               },
    //             })}
    //             placeholder="Year"
    //           />
    //           {errors.end_year && (
    //             <p className="error-message">{errors.end_year.message}</p>
    //           )}
    //         </div>
    //       </div>
    //     )}

    //     <div className="experience-form-field">
    //       <label>Location</label>
    //       <input
    //         {...register("location")}
    //         placeholder="Ex: London, United Kingdom"
    //       />
    //     </div>

    //     <div className="experience-form-field">
    //       <label>Location Type</label>
    //       <select {...register("location_type")}>
    //         <option value="">Please select</option>
    //         <option value="Onsite">Onsite</option>
    //         <option value="Hybrid">Hybrid</option>
    //         <option value="Remote">Remote</option>
    //       </select>
    //     </div>

    //     <div className="experience-form-field">
    //       <label>Skills</label>
    //       <input
    //         {...register("skills")}
    //         placeholder="Comma separated skills (e.g., React,Node)"
    //         onBlur={(e) =>
    //           setValue(
    //             "skills",
    //             e.target.value.split(",").map((s) => s.trim())
    //           )
    //         }
    //       />
    //     </div>

    //     {/* Show existing media if editing */}
    //     {defaultValues?.media && typeof defaultValues.media === "string" && (
    //       <div className="form-group">
    //         <label>Existing Media:</label>
    //         <div style={{ marginBottom: "6px" }}>
    //           <a
    //             href={defaultValues.media}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{ color: "#007bff", textDecoration: "underline" }}
    //           >
    //             View Uploaded Media
    //           </a>
    //         </div>
    //         <p style={{ fontSize: "0.8rem", color: "gray" }}>
    //           Uploading a new file will replace the existing one.
    //         </p>
    //       </div>
    //     )}

    //     {/* Media upload input */}
    //     <div className="form-group">
    //       <label htmlFor="media">Upload Media (optional)</label>
    //       <input type="file" id="media" {...register("media")} />
    //     </div>

    //     <div className="experience-form-field">
    //       <label>Description</label>
    //       <textarea
    //         {...register("description")}
    //         placeholder="List your major duties and achievements"
    //         rows={3}
    //       />
    //     </div>

    //     <div className="experience-form-actions">
    //       <button
    //         type="submit"
    //         disabled={Object.keys(errors).length > 0}
    //         className="save-btn"
    //       >
    //         {loading ? <ThreeDot color={["#ffff"]} size="small" /> : "Save"}{" "}
    //       </button>
    //     </div>
    //   </form>
    // </div>
    <div className="max-w-xl w-full mx-auto">
  <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
    {/* Title */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">
          Title <span className="text-red-500">*</span>
        </label>
      </div>
      <input
        {...register("title", { required: true })}
        placeholder="Ex: Retail Sales Manager"
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Employment Type */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Employment Type</label>
      </div>
      <select
        {...register("employment_type")}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
      >
        <option value="">Please select</option>
        <option value="Full-time">Full-time</option>
        <option value="Part-time">Part-time</option>
        <option value="Internship">Internship</option>
        <option value="Freelance">Freelance</option>
      </select>
    </div>

    {/* Company */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">
          Company or Organization <span className="text-red-500">*</span>
        </label>
      </div>
      <input
        {...register("company", { required: true })}
        placeholder="Ex: Microsoft"
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Current Role Checkbox */}
<label className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl cursor-pointer select-none">
  <input
    type="checkbox"
    {...register("is_current")}
    className="sr-only peer"
  />
  <div className="w-5 h-5 border-2 border-gray-300 rounded flex items-center justify-center peer-checked:bg-[#0f6abf] transition-colors">
    <Check className="w-3 h-3 text-white hidden peer-checked:block" />
  </div>
  <span className="text-sm text-gray-700">I am currently working in this role</span>
</label>

    {/* Start Date */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Start Date</label>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <select
            {...register("start_month")}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 16px center'
            }}
          >
            <option value="">Month *</option>
            {[
              "January","February","March","April","May","June",
              "July","August","September","October","November","December",
            ].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>

        <div>
          <input
            type="number"
            {...register("start_year", {
              required: "Start year is required",
              min: { value: 1900, message: "Year cannot be before 1900" },
              max: { value: new Date().getFullYear() + 5, message: "Year seems too far in the future" },
              validate: (value) =>
                /^\d{4}$/.test(value) || "Year must be a 4-digit number",
            })}
            placeholder="Year *"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
          {errors.start_year && (
            <p className="text-red-500 text-xs mt-2">{errors.start_year.message}</p>
          )}
        </div>
      </div>
    </div>

    {/* End Date (if not current) */}
    {!is_current && (
      <div>
        <div className="flex items-center gap-2 mb-3">
         
          <label className="text-sm font-semibold text-gray-700">End Date</label>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <select
              {...register("end_motnh")}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 16px center'
              }}
            >
              <option value="">Month</option>
              {[
                "January","February","March","April","May","June",
                "July","August","September","October","November","December",
              ].map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>

          <div>
            <input
              type="number"
              {...register("end_year", {
                required: "End year is required",
                min: { value: 1900, message: "Year cannot be before 1900" },
                max: { value: new Date().getFullYear() + 5, message: "Year seems too far in the future" },
                validate: (value) => {
                  const startYear = watch("start_year");
                  return !value || parseInt(value) >= parseInt(startYear) || "End year must be after start year";
                },
              })}
              placeholder="Year"
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            />
            {errors.end_year && (
              <p className="text-red-500 text-xs mt-2">{errors.end_year.message}</p>
            )}
          </div>
        </div>
      </div>
    )}

    {/* Location */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Location</label>
      </div>
      <input
        {...register("location")}
        placeholder="Ex: London, United Kingdom"
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Location Type */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Location Type</label>
      </div>
      <select
        {...register("location_type")}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
      >
        <option value="">Please select</option>
        <option value="Onsite">Onsite</option>
        <option value="Hybrid">Hybrid</option>
        <option value="Remote">Remote</option>
      </select>
    </div>

    {/* Skills */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Skills</label>
      </div>
      <input
        {...register("skills")}
        placeholder="Comma separated skills (e.g., React, Node.js, Python)"
        onBlur={(e) =>
          setValue(
            "skills",
            e.target.value.split(",").map((s) => s.trim())
          )
        }
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Existing Media */}
    {defaultValues?.media && typeof defaultValues.media === "string" && (
      <div className="p-4 bg-gray-50 rounded-xl">
        <div className="flex items-center gap-2 mb-2">
         
          <label className="text-sm font-semibold text-gray-700">Existing Media</label>
        </div>
        <a
          href={defaultValues.media}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-[#0f6abf] hover:underline inline-flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View Uploaded Media
        </a>
        <p className="text-xs text-gray-500 mt-2">
          Uploading a new file will replace the existing one.
        </p>
      </div>
    )}

    {/* Media Upload */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Upload Media (optional)</label>
      </div>
      <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center">
        <input 
          type="file" 
          id="media" 
          {...register("media")} 
          className="hidden"
        />
        <label 
          htmlFor="media" 
          className="cursor-pointer inline-flex flex-col items-center"
        >
          <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
            <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
          </div>
          <span className="text-sm text-gray-700">Choose file</span>
          <span className="text-xs text-gray-500 mt-1">JPG, PNG, PDF up to 10MB</span>
        </label>
      </div>
    </div>

    {/* Description */}
    <div>
      <div className="flex items-center gap-2 mb-3">
       
        <label className="text-sm font-semibold text-gray-700">Description</label>
      </div>
      <textarea
        {...register("description")}
        placeholder="List your major duties and achievements..."
        rows={4}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-y"
      />
    </div>

    {/* Form Actions */}
    <div className="sticky bottom-0 bg-white pt-6  border-t border-gray-100">
      <div className="flex justify-end gap-3">
        <button
          type="submit"
          disabled={Object.keys(errors).length > 0}
          className="px-6 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center gap-2"
        >
          {loading ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Saving...
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Save
            </>
          )}
        </button>
      </div>
    </div>
  </form>
</div>
  );
};

export default ExperienceForm;
